var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-typography',{attrs:{"single":""}},[_c('base-text',{attrs:{"value":_vm.meetingIndexText}}),_c('base-text',{staticClass:"ml-2",attrs:{"value":_vm.meetingDatetimeText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }